// TableNotificacionInventario.tsx

import { CustomAutocompleteArrStringNoForm, GeneralTable } from "@/shared/components/ui";
import { NotificacionInventario } from "../../types";
import { hasPermission, ROUTER_PATHS, sanitizeTodos, TABLE_CONSTANTS_COLUMS, useLoaders, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import { useTableColumnsNotificacionInventario } from "../../hooks";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useFetchGetNotificacionInventario, useFetchPutNotificacionInventario } from "@/shared/actions";
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { Cached, East, HighlightOff, TaskAlt } from "@mui/icons-material";
import { useState } from "react";
import { useUiStore } from "@/store/ui";
import { ESTADO_NOTIFICACION_INVENTARIO_LABELS, EstadoNotificacionEnum } from "../../utils/notificacion-inventario.choice";
import { useNavigate } from "react-router-dom";


type TableNotificacionInventarioProps = {
  modulo: 'TECNICO' | 'INVENTARIO';
}

export default function TableNotificacionInventario({
  modulo
}: TableNotificacionInventarioProps) {


  const navigate = useNavigate();

  const [estado, setEstado] = useState<string>('TODOS');

  /// fetch
  const { mutateAsync, isPending } = useFetchPutNotificacionInventario({})

  // hook
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);

  const {
    pagination,
    setPagination
  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    columns
  } = useTableColumnsNotificacionInventario()

  // fetch
  const {
    isLoading,
    data,
    isRefetching,
    refetch
  } = useFetchGetNotificacionInventario({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      estado_notificacion_inventario: sanitizeTodos(estado),
      ...filterObject,
      filterByState: false
    }
  });

  useLoaders(isPending)

  const handleAccion = (value: NotificacionInventario, estado: string) => {

    setConfirmDialogIsOpen(true);
    setConfirmDialog({
      cancelTextBtn: "Salir",
      isOpen: true,
      title: "¡Confirmar!",
      subtitle:
        `Estas por ${estado === EstadoNotificacionEnum.APROBADO ? 'APROBAR' : 'RECHAZAR'} la notificación de inventario. ¿Estás seguro de que deseas continuar?`,
      onClose() {
        setConfirmDialogIsOpen(false);
      },
      async onConfirm() {
        setConfirmDialogIsOpen(false);
        try {

          mutateAsync({
            id: value.id_notificacion_inventario,
            data: {
              estado_notificacion_inventario: estado
            }
          })

        } catch (err) {
          console.error("Error al procesar la transferencia:", err);
        }
      },
    });
  }


  const handleNavigate = (id: string) => {
    navigate(`${ROUTER_PATHS.inventario.trasladoInventarioCreateNotificacion}/${id}`);
  }

  return <>
    <Grid container justifyContent={'flex-end'} alignItems={'center'} spacing={2}>
      <Grid item xs={3}>
        <CustomAutocompleteArrStringNoForm
          required={false}
          label="Estado"
          defaultValue={'TODOS'}
          options={ESTADO_NOTIFICACION_INVENTARIO_LABELS}
          onChangeValue={(value) => {
            setEstado(value);
          }}
        />
      </Grid>

      <Grid item xs={1}>
        <IconButton
          onClick={() => refetch()}
          color="primary"
          size="medium"
          sx={{
            bgcolor: "primary.main",
            color: "white",
            width: 40,
            height: 40,
            transition: "all 0.3s ease",
            "&:hover": {
              bgcolor: "primary.dark",
            },
          }}
        >
          <Cached />
        </IconButton>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<NotificacionInventario>
          columns={columns}
          data={data?.data?.data || []}
          isLoading={isLoading}
          isRefetching={isRefetching}
          // search
          enableGlobalFilter={false}
          // filters
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={data?.data?.count}
          // actions
          actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL}
          positionActionsColumn="first"
          editIcon={<OpenInNewIcon />}
          canEdit={false}
          enableColumnActions={true}
          canDelete={false}
          enableEditing={true}
          showCustomActionBtnSpace={true}
          customActionBtnSpace={(value) => {

            const estado = value.estado_notificacion_inventario;

            return <Grid container>

              {
                (estado === EstadoNotificacionEnum.APROBADO || estado === EstadoNotificacionEnum.EXPIRADO) && null
              }

              {
                estado === EstadoNotificacionEnum.APROBADO && modulo === 'INVENTARIO' && (
                  <Grid item>
                    <Tooltip title="Continuar Traslado">
                      <IconButton
                        onClick={() => handleNavigate(value.id_notificacion_inventario)}
                      >
                        <East color="info" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )
              }

              {
                estado === EstadoNotificacionEnum.PENDIENTE && modulo === 'TECNICO' && (
                  <>
                    <Grid item>
                      <Tooltip title="Aprobar">
                        <IconButton
                          onClick={() => handleAccion(value, EstadoNotificacionEnum.APROBADO)}
                        >
                          <TaskAlt color="success" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      <Tooltip title="Rechazar">
                        <IconButton
                          onClick={() => handleAccion(value, EstadoNotificacionEnum.RECHAZADO)}
                        >
                          <HighlightOff color="error" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </>
                )
              }

            </Grid>
          }}
        />
      </Grid>

    </Grid>

  </>
}
